import React from "react";
import { motion } from "framer-motion";
import { PRACTICE_AREAS } from "./trenasData";
import TrenasLayout, { NAVY, GOLD, CREAM, SLATE } from "./TrenasLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function TrenasPracticeAreas() {
  return (
    <TrenasLayout active="practice-areas">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}>Practice Areas</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 trenas-serif text-3xl sm:text-5xl text-white">Where We Can Help</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 gap-6">
          {PRACTICE_AREAS.map((s, i) => (
            <motion.div key={s.title} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.04 }} className="bg-white rounded-lg p-6 shadow-sm border-l-4" style={{ borderColor: GOLD }}>
              <h3 className="trenas-serif text-lg" style={{ color: NAVY }}>{s.title}</h3>
              <p className="mt-1.5 text-sm" style={{ color: SLATE }}>{s.text}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </TrenasLayout>
  );
}
